import { applyEach, applyWhen, disabled, schema, validate } from '@angular/forms/signals';
import { Produktdaten } from '../../../../generated/model/produktdaten.model';
import { ZaehlerType } from '../../../model/zaehler-typ.model';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { validateOptionalWithControlValidator, validateRequired, validateWithControlValidator } from '@shared-ikp/utils/signal-forms.util';

export interface ZaehlerSpecsFormValue {
  zaehlerType: ZaehlerType | null;
  zaehlerstand: string | null;
  hasNoZaehlerstand: boolean;
}

export interface ProduktEintragFormValue {
  category: Produktdaten.ProduktEnum | undefined;
  isSelected: boolean;
  zaehlpunktnummer: string;
  zaehlerNr: string | null;
  zaehlerSpecs: ZaehlerSpecsFormValue;
}

export interface ProduktFormValue {
  produkte: ProduktEintragFormValue[];
}

const zaehlerstandSchema = schema<ZaehlerSpecsFormValue>(path => {
  validate(path.zaehlerstand, validateOptionalWithControlValidator(CustomValidators.meterCountValidator, 'zaehlerstand'));
});

export const produktSchema = schema<ProduktFormValue>(path => {
  applyEach(path.produkte, produkt => {
    disabled(produkt.isSelected, () => true);
    disabled(produkt.zaehlerSpecs.zaehlerstand, ({ valueOf }) => valueOf(produkt.zaehlerSpecs.hasNoZaehlerstand));
    validate(produkt.zaehlerNr, validateWithControlValidator(CustomValidators.meterNumberValidator, 'zaehlerNr'));
    applyWhen(
      produkt.zaehlerSpecs,
      ctx => ctx.value().zaehlerType === ZaehlerType.KONVENTIONELL && !ctx.value().hasNoZaehlerstand,
      zaehlerstandSchema,
    );
  });
});

/** Required-field rules, only applied when the step is validated for completeness (signing). */
export const produktPflichtfelderSchema = schema<ProduktFormValue>(path => {
  applyEach(path.produkte, produkt => {
    validate(produkt.zaehlerNr, validateRequired('inputErrors.blank.meterNumber'));
  });
});
